import { ChartContainer } from 'components/Charting/Container/Container.styled';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { AppThemeType } from 'store/types';
import styled from 'styled-components';

export const TradedVolumeContainer = styled(ChartContainer)<{
  $fullScreen: boolean;
  $appTheme: AppThemeType;
}>`
  ${({ $fullScreen, theme, $appTheme }) => `
  position: relative;

  ${
    $fullScreen
      ? `
    display: flex;
    flex-direction: column;
    height: 100%;
    `
      : `
    height: 400px;
    `
  }

    .bar:hover, .hovered-bar {
      stroke: ${cxTheme.colors.blue.lighten20};
      stroke-width: 0.5;
      rx: ${cxTheme.borderRadius.primaryRadius};
      filter: drop-shadow(2px 4px 4px rgba(0, 32, 92, 0.2));
    }

    .x-grid-line, .y-grid-line, .y-axis {
      stroke: ${theme.border.medium};
    }
    
    .y-grid-line.y-grid-line-zero-axis {
      stroke-dasharray: 3;
      stroke-width: 2;
      stroke: ${$appTheme === 'light' ? `${theme.border.strong}` : `${theme.border.medium}`};
    }
    
    .y-grid-line.y-grid-line-hidden {
      display: none;
    }
    
    .x-tick, .y-tick {
      fill: ${theme.text.onSurface.subtle};
    }

    .x-axis {
      stroke: ${theme.border.medium};
    }
    
    .x-axis, .y-axis {
      display: none;
    }

    @media screen and (min-width: ${cxTheme.breakpoints.desktop}px) {
      .x-efa-tick {
        display: block;
      }
    }

    ${
      !$fullScreen &&
      `@media screen and (min-width: 2018px) {
     height: 800px; 
    }`
    }
  `}
`;

export const ContractedVolumeContainer = styled.div`
  background: ${({ theme }) => theme.background.surface};
  padding-bottom: ${({ theme }) => cxTheme.spacing[7]};
  border-radius: 12px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.elevation.level0};

  .shell-button {
    border-color: ${({ theme }) => theme.border.medium};

    &:hover {
      border-color: ${({ theme }) => theme.border.strong};
    }
  }

  @media screen and (max-width: ${cxTheme.breakpoints.desktop}px) {
    border-radius: 0;
  }
`;
